import React from 'react';
import styled from 'styled-components';
import { mobileMediaQuery } from '../../../Theming';
import { SvgProps } from '../core';

const StyledSVG = styled.svg`
  ${mobileMediaQuery} {
    margin-left: 25px;
    width: 105.16px;
    height: 112.19px;
  }
`;

const HowItworksDeals: React.FC<SvgProps> = ({
  width = 156,
  height = 159,
  className,
}) => {
  return (
    <StyledSVG
      width={width}
      height={height}
      className={className}
      viewBox="0 0 146 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.3847 45.8329C30.3824 48.5909 30.7169 51.3388 31.3807 54.0149C31.5796 54.815 31.6154 55.6473 31.486 56.4617C31.3566 57.2761 31.0645 58.0557 30.6275 58.7536C30.1905 59.4515 29.6175 60.0533 28.943 60.5226C28.2686 60.9919 27.5067 61.3191 26.7031 61.4844C22.2813 62.4023 18.3554 64.9371 15.6852 68.5982C13.0151 72.2593 11.7905 76.7863 12.2487 81.303C12.7069 85.8197 14.8151 90.0049 18.1654 93.0485C21.5156 96.0921 25.8697 97.7777 30.3847 97.779H109.391C112.79 97.7747 116.15 97.0539 119.254 95.6631C122.359 94.2722 125.139 92.2422 127.415 89.7041C129.691 87.166 131.412 84.1762 132.468 80.9277C133.524 77.6792 133.89 74.2442 133.544 70.8444C133.198 67.4445 132.147 64.1555 130.458 61.1895C128.77 58.2235 126.482 55.6465 123.741 53.6248C121.001 51.6032 117.87 50.1817 114.549 49.4523C111.229 48.7229 107.793 48.7017 104.464 49.3901C103.611 49.5664 102.73 49.5563 101.881 49.3603C101.032 49.1644 100.235 48.7873 99.5438 48.2545C98.8525 47.7217 98.2831 47.0457 97.8743 46.2723C97.4655 45.4989 97.2268 44.6461 97.1743 43.7718C96.6349 35.0572 92.7443 26.8956 86.3261 21.0146C79.9078 15.1337 71.4656 11.9949 62.7865 12.2627C54.1073 12.5306 45.8724 16.1839 39.8248 22.4496C33.7773 28.7152 30.3917 37.1013 30.3847 45.8329ZM18.2298 45.8329C18.2315 34.4732 22.4276 23.5189 30.0047 15.0935C37.5819 6.66809 48.0002 1.37188 59.24 0.231622C70.4797 -0.908634 81.7401 2.1883 90.8382 8.92203C99.9362 15.6558 106.224 25.5466 108.482 36.6769C108.784 36.6693 109.087 36.6654 109.391 36.6654C114.192 36.6463 118.949 37.5806 123.39 39.4148C127.83 41.2489 131.867 43.9468 135.269 47.3535C138.67 50.7603 141.369 54.8089 143.21 59.267C145.052 63.7252 146 68.5051 146 73.3326C146 78.16 145.052 82.94 143.21 87.3981C141.369 91.8563 138.67 95.9049 135.269 99.3116C131.867 102.718 127.83 105.416 123.39 107.25C118.949 109.084 114.192 110.019 109.391 110H30.3847C23.3735 109.998 16.5787 107.558 11.1515 103.095C5.72432 98.6317 1.99865 92.4188 0.605819 85.5092C-0.787011 78.5996 0.238665 71.4182 3.50904 65.1821C6.77942 58.9459 12.0933 54.0385 18.5504 51.2914C18.3365 49.4798 18.2295 47.6571 18.2298 45.8329Z"
        fill="#1B2457"
      />
    </StyledSVG>
  );
};

export default HowItworksDeals;
